import React from 'react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { FormControl } from '@/components/ui/form';

const FormControlString = ({ field, property, name }) => {
  if (property.enum) {
    // Enum/select field
    return (
      <Select
        onValueChange={field.onChange}
        defaultValue={field.value}
      >
        <FormControl>
          <SelectTrigger>
            <SelectValue placeholder={`Select ${name}`} />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {property.enum.map(option => (
            <SelectItem key={option} value={option}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );  
  } else {
    // Regular text input
    return (
      <FormControl>
        <Input {...field} placeholder={`Enter ${name}`} />
      </FormControl>
    );
  }
};

export default FormControlString;